<template>
  <div id="app">
    <player
      src="https://videas.agglo-lenslievin.fr/index.m3u8"
      :options="themeFinalOptions"
    ></player>
  </div>
</template>

<script>
import player from "@/components/videas-player/ui";
import merge from "lodash/merge";
import cloneDeep from "lodash/cloneDeep";

import defaultThemeOptions from "@/data/playerOptions";

export default {
  name: "App",
  components: {
    player
  },
  data() {
    return {
      error: false,
      isEncoding: false
    };
  },
  computed: {
    themeFinalOptions() {
      return merge(cloneDeep(defaultThemeOptions), this.options);
    }
  }
};
</script>

<style lang="stylus">
#app, body, html, .v-app, .v-content
  overflow: hidden !important;
  background-color: #000;
  height: 100vh;
  width: 100%
</style>
